module.exports = __webpack_public_path__ + "img/happytogether_option_02.613c134b.jpg";